import { useEffect, useState } from "react";

import { AUTH_ROUTE_PATHS } from "@jti/fe-common/routes/auth-routes";
import { useAuthHrefResolver } from "@jti/ui/providers/AuthRoutingProvider";

export const REPLACE_URL_PLACEHOLDER = "{#loginWithRedirection#}";

/**
 * Hook that replaces the login placeholder with an actual URL containing the current page as returnUrl.
 * Returns the placeholder initially (for SSR) and updates to the actual URL on mount (client-side only).
 * This prevents hydration errors in Next.js.
 */
export const useLoginRedirectionUrl = (link: string): string => {
  const [processedLink, setProcessedLink] = useState(link);
  const resolveAuthHref = useAuthHrefResolver();

  useEffect(() => {
    // Only run on client-side after mount
    if (link === REPLACE_URL_PLACEHOLDER) {
      setProcessedLink(
        resolveAuthHref({
          route: AUTH_ROUTE_PATHS.login,
          search: { returnUrl: window.location.href },
        })
      );
    }
  }, [link, resolveAuthHref]);

  return processedLink;
};
